import { render, staticRenderFns } from "./blogDetails.vue?vue&type=template&id=c83b68c2"
import script from "./blogDetails.vue?vue&type=script&lang=js"
export * from "./blogDetails.vue?vue&type=script&lang=js"
import style0 from "./blogDetails.vue?vue&type=style&index=0&id=c83b68c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports